import { useMemo } from 'react';

import { getParticipantLineItemGroups } from '@order/features-ordering';

import type { PartialLineItem } from '../../../../../../graphql';

// ─────────────────────────────────────────────────────────────────────────────

export const useFormattedBagLineItems = (params: Params) => {
  const { isGroupOrder, lineItems } = params;

  // ─── Derived ──────────────────────────────────────────────────────────────

  return useMemo(() => {
    if (!isGroupOrder) {
      return {
        lineItemGroups: [{ id: SOLO_ORDER_GROUP_ID, isMe: true, lineItems }],
        shouldShowParticipantHeaders: false,
      };
    }

    return {
      lineItemGroups: getParticipantLineItemGroups(lineItems),
      shouldShowParticipantHeaders: true,
    };
  }, [isGroupOrder, lineItems]);
};

// ─── Constants ───────────────────────────────────────────────────────────────

const SOLO_ORDER_GROUP_ID = 'solo-order';

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  isGroupOrder: boolean;
  lineItems: readonly PartialLineItem[];
};
